export const WOW = "common.wow";
export const MOM = "common.mom";
